export default (el) => {

    document.querySelectorAll('.strate-hero .bg-load').forEach(function(element) {
        element.remove();
    });

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    if(getCookie('is-view')){
        document.getElementById('header').classList.add('is-view');
        document.querySelectorAll('.strate-hero').forEach(function(element) {
            element.classList.add('expanded');
            element.classList.add('is-view');
        });
        document.querySelectorAll('.image-container .strate-hero').forEach(function(element) {
            element.classList.add('is-view');
        });
    }




    window.addEventListener('beforeunload', () => {
        if (window.innerWidth >= 1024 && !document.querySelector('.strate-hero').classList.contains('expanded')) {
            window.scrollTo(0, 0);
        }
    });
    const header = document.querySelector('#header');
    
    if (window.innerWidth >= 1024 && !document.querySelector('.strate-hero').classList.contains('expanded')) {
        document.body.style.overflow = 'hidden';
        header.classList.add('header-hidden');
    }

    var expandButton = document.getElementById('expand-button');
    var imageContainer = document.querySelector('.image-container');
    var strateHero = imageContainer.closest('.strate-hero');

    expandButton.addEventListener('click', function (event) {
        event.preventDefault();
        setCookie("is-view", "true", 1);
        imageContainer.classList.add('animate-expand');

        setTimeout(function () {
            strateHero.classList.add('expanded');
            document.body.style.overflow = '';

            if (window.innerWidth >= 1024) {
                header.classList.remove('header-hidden');
            }
        }, 1000);
    });

};
